import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import SupplierPaymentInfo from '@/components/Partners/SupplierPaymentInfo';
import SupplierReviewsCarousel from '../SupplierReviewsCarousel';
import SupplierStats from '../SupplierStats';
import classNames from 'classnames';
import { EventSource } from '@/shared/constants/event';
import { Faqs } from '@/components/Common';
import { Overview } from '@/components/Home';
import { STATIC_FILE_URL } from '@/shared/constants';
import { SUPPLIER_INFORMATIONAL_SECTIONS, SUPPLIER_STEPS } from '@/shared/utils/homepage-util';
import { SUPPLIER_TOP_FAQ } from '@/shared/constants/faq';
import { imageTransform } from '@/shared/utils/utils';
import { supplierPortalLink } from '@/lib/service';
import './index.less';

const PartnerLandingPage = () => {
  const partnerPortalLoginLink = `${supplierPortalLink()}/login?create_account=true&utm_source=website`;

  const headerItems = [
    {
      title: 'Sign Up As A Product Supplier',
      image: `${STATIC_FILE_URL}/13d83f64974b212d1b9017fe07a8f1f8.png`,
    },
    {
      title: 'Sign Up As A Packaging Supplier',
      image: `${STATIC_FILE_URL}/672dddc5a509985830b04bdc180c491d.png`,
    },
    {
      title: 'Sign Up As A Creative Service Provider',
      image: `${STATIC_FILE_URL}/5d562de8a3fa409fee896786433abf04.png`,
    },
  ];

  return (
    <div className="pietra-suppliers">
      <div className="outer">
        <div className="header">
          <span className="title">
            List your private label products, manufacturing capabilities, and creative services.
          </span>
          <Link href={partnerPortalLoginLink} target="_blank" className="action-button">
            Get Free Leads
          </Link>
          <div className="items">
            {headerItems.map((item, i) => (
              <Link key={i} className="item" href={partnerPortalLoginLink} target="_blank">
                <Image src={imageTransform(item.image, 'large')} fill alt={item.title} title={item.title} />
                <div className="text">
                  <span className="title">{item.title}</span>
                  <Image src="/images/carousel_next.png" width={34} height={34} alt="Next Slide" title="Next Slide" />
                </div>
              </Link>
            ))}
          </div>
        </div>
        <SupplierStats />
        <SupplierPaymentInfo />
        <SupplierReviewsCarousel signup={() => window.open(partnerPortalLoginLink)} />
        <Overview steps={SUPPLIER_STEPS} actionEventPage={EventSource.PIETRA_PARTNERS_LANDING_PAGE} />
        <div className="module-5">
          <div className="left">
            <span className="title">Less Work. More Customers.</span>
            <div className="image-container">
              <Image
                width={473}
                height={320}
                src={imageTransform(`${STATIC_FILE_URL}/d093ebe48ebc3d88d223cc5121fce0e1.png`, 'large')}
                className="img-1"
                alt="Pietra Partner Portal"
                title="Pietra Partner Portal"
              />
              <Image
                width={220}
                height={340}
                src={imageTransform(`${STATIC_FILE_URL}/2005d5c1711283ea51cf3c84098324ac.png`, 'large')}
                className="img-2"
                alt="Worldwide shipping"
                title="Worldwide shipping"
              />
            </div>
          </div>
          <div className="right">
            {SUPPLIER_INFORMATIONAL_SECTIONS.map((section, i) => (
              <div className="section" key={i}>
                <span className="title">{section.title}</span>
                <span className="text">
                  <span>{section.text}</span>
                  <Link
                    className={classNames('button', 'underline-transition')}
                    href={partnerPortalLoginLink}
                    target="_blank"
                  >
                    Sign Up
                  </Link>
                </span>
              </div>
            ))}
          </div>
        </div>
        <div className="module-6">
          <h2 className="title">Popular Questions</h2>
          <span className="desc">
            Here&apos;s what other suppliers are asking before signing up for Pietra. If you have any questions that
            aren&apos;t listed here, please email
            <a target="_blank" href="mailto:suppliers@pietrastudio.com">
              suppliers@pietrastudio.com
            </a>
          </span>
          <Faqs className="faqs-container" faqs={SUPPLIER_TOP_FAQ} />
          <Link href="/supplier-faq" className="action-button">
            See Full FAQ
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PartnerLandingPage;
